<template>
  <div class="accepted-details-container">
    <div v-if="details && details.is_accepted">
      <div class="detail-item">
        <label>Date & Time Accepted</label>
        <p>{{ formattedAcceptedDate }}</p>
      </div>
      <div class="detail-item" v-if="details.organisation_name">
        <label>Organisation Name</label>
        <p>
          {{ details.organisation_name }}
          <span v-if="details.original_organisation_name && details.original_organisation_name !== details.organisation_name" class="badge bg-light text-secondary border ms-2" style="font-size: 0.8em; font-weight: normal;">
            <i class="fa-solid fa-history me-1"></i> Formerly: {{ details.original_organisation_name }}
          </span>
        </p>
      </div>
      <div class="detail-item" v-if="details.abn">
        <label>Organisation ABN</label>
        <p>
          {{ details.abn }}
          <span v-if="details.original_abn && details.original_abn !== details.abn" class="badge bg-light text-secondary border ms-2" style="font-size: 0.8em; font-weight: normal;">
            <i class="fa-solid fa-history me-1"></i> Formerly: {{ details.original_abn }}
          </span>
        </p>
      </div>
      <div class="detail-item">
        <label>Accepted By (Email)</label>
        <p>{{ details.accepted_by_email || 'N/A' }}</p>
      </div>
      <div class="detail-item">
        <label>Accepted From IP Address</label>
        <p>{{ details.accepted_by_ip || 'N/A' }}</p>
      </div>
      <div class="detail-item">
        <label>Option Accepted</label>
        <p>{{ acceptedOptionText }}</p>
      </div>
      <div class="detail-item">
        <label>Value Accepted</label>
        <p>{{ details.total_accepted }}</p>
      </div>

      <div class="detail-item">
        <label>Products & Services Accepted</label>
        <div class="items-list-container">
            <div v-if="details.accepted_items && details.accepted_items.length > 0">
                <div v-for="item in details.accepted_items" :key="item.id" class="accepted-item">
                    <span class="item-name">
                        {{ item.Product.display_name || "none"  }}
                        <span class="item-qty">({{ item.quantity }}x)</span>
                    </span>
                    <span class="item-price">{{ formatCurrency((item.price - item.discount) * item.quantity) }}</span>
                </div>
            </div>
            <div v-else class="text-muted">
                No specific items were recorded for this acceptance.
            </div>
        </div>
      </div>

    </div>
    <div v-else class="not-accepted-message">
      <p>This proposal has not been accepted yet.</p>
    </div>
  </div>
</template>

<script>
import { toOptionName } from '@/plugins/helper.js';

export default {
  name: 'ProposalAcceptedDetails',
  props: {
    details: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    formatCurrency(value) {
      const numericValue = parseFloat(value);
      if (isNaN(numericValue)) {
        return '$0.00';
      }
      // Adds GST (10%) to the line item total for display
      return `$${(numericValue * 1.1).toFixed(2)}`;
    }
  },
  computed: {
    formattedAcceptedDate() {
      if (!this.details.accepted_at) return 'N/A';
      return this.details.accepted_at;
    },
    acceptedOptionText() {
        if (!this.details.option_index_selected) return 'N/A';
        if (this.details.option_index_selected === 1) return 'Main Option';
        return `Option ${toOptionName(this.details.option_index_selected)}`;
    }
  }
};
</script>

<style scoped>
.accepted-details-container {
  padding: 1rem;
  font-family: "Roboto", sans-serif;
}
.detail-item {
  margin-bottom: 1.2rem;
}
.detail-item label {
  display: block;
  font-weight: bold;
  color: #00A0C1;
  font-size: 0.9em;
  margin-bottom: 0.3rem;
}
.detail-item p {
  margin: 0;
  padding: 0.6rem;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 10px;
  color: #435666;
  font-size: 0.95em;
  word-wrap: break-word;
}
.not-accepted-message {
  text-align: center;
  color: #6c757d;
  padding: 2rem;
  background-color: #f8f9fa;
  border: 1px dashed #ced4da;
  border-radius: 5px;
}
.items-list-container {
  min-height: 40px;
  padding: 0.6rem 0.75rem;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 10px;
}
.accepted-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem 0.2rem;
  border-bottom: 1px solid #dee2e6;
  font-size: 0.95em;
}
.accepted-item:last-child {
  border-bottom: none;
}
.item-name {
  color: #435666;
  font-weight: 500;
}
.item-qty {
  color: #6c757d;
  font-weight: 400;
}
.item-price {
  color: #00A54F;
  font-weight: bold;
}
.text-muted {
    color: #6c757d;
}
</style>